import {
  Directive,
  HostListener,
  HostBinding,
  Input,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';


@Directive({
  selector: '[formControlDimension]',
  exportAs: 'form-control-dimension',
})
export class FormControlDimensionDirective {

  @Input() formControl: UntypedFormControl;

  @HostBinding('attr.placeholder')
  @Input() placeholder: string = '';

  // handlers
  @HostListener('focus', ['$event.target.value'])
  onFocus(value: any) {
    this.formControl.setValue(this.completeValue(value));
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value: any) {
    this.formControl.setValue(this.completeValue(value));
    if (this.formControl.pristine) { this.formControl.markAsDirty(); }
  }

  // private

  private completeValue(value: string): string {
    if (value.indexOf('.') === -1) {
      return `${value.length ? value : '0'}.0000`;
    }
    const split = value.split('.');
    let decimal = split[1];
    while (decimal.length < 4) {
      decimal += '0';
    }
    return `${split[0]}.${decimal}`;
  }
}
